import axios from "axios";
import { BASE_END_POINT } from "../../urls";
import { message } from "antd";
// Function to get request History
export const getRequestHistoryApi = async (id, token, isRTL) => {
    try {
        const response = await axios.get(`${BASE_END_POINT}requests/${id}/getHistory`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'Accept-Language': isRTL ? 'ar' : 'en',
            }
        });
        return response.data;
    } catch (error) {
        console.log(error.response)
    }

};
// Function to get ad suggested info
export const getSuggestedAdvertisementsApi = async (page, id, token, isRTL) => {
    try {
        const response = await axios.get(`${BASE_END_POINT}requests/${id}/getSuggestedAdvertisements?page=${page}&limit=${10}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'Accept-Language': isRTL ? 'ar' : 'en',
            }
        });
        return response.data;
    } catch (error) {
        console.log(error.response)
    }

};
// Function to delete an ad
export const deleteApi = async (id, token, isRTL, allStrings) => {
    let l = message.loading('Wait..', 2.5);
    try {
        const response = await axios.delete(`${BASE_END_POINT}requests/${id}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'Accept-Language': isRTL ? 'ar' : 'en',
            },
        });
        l.then(() => message.success(allStrings.done, 2.5));
        return response.data;
    } catch (error) {
        console.log(error.response)
        l.then(() => message.error(allStrings.error, 2.5))
    }

};
// Function to update status
export const updateStatusApi = async (id, state, token, isRTL, allStrings) => {
    let l = message.loading('Wait..', 2.5);
    try {
        let data = {
            clientType: state.clientType,
            clientStatus: state.clientStatus,
            notes: state.notes
        }
        if (state.priceFrom && state.priceTo && state.clientStatus === "INTEREST-IN-ANOTHER-OFFER") {
            data.priceFrom = state.priceFrom
            data.priceTo = state.priceTo
            data.city = state.city
            if (state.area != null) data.area = state.area
            data.category = state.category
            data.subCategory = state.subCategory
            data.direction = state.direction
        }
        if (state.rate) data.rate = state.rate
        if (state.currentProject) data.currentProject = state.currentProject
        const response = await axios.put(`${BASE_END_POINT}requests/${id}/updateStatus`, data, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'Accept-Language': isRTL ? 'ar' : 'en'
            },
        });
        l.then(() => message.success(allStrings.done, 2.5));
        return response.data;
    } catch (error) {
        console.log(error.response)
        if (error.response.data.errors[0].msg) {
            l.then(() => message.error(error.response.data.errors[0].msg, 2.5))
        } else {
            l.then(() => message.error(allStrings.error, 2.5))
        }
    }
};
